import {Moon, Sun} from 'lucide-react';
import React from 'react';
import useTheme from 'src/hooks/useTheme';
import {MenuButton} from 'src/SideNav/MenuItem';

export const LightDarkThemeButton = () => {
  const {theme, toggleTheme} = useTheme();

  const icon = theme === 'dark' ? <Sun /> : <Moon />;
  const label = theme === 'dark' ? 'Light mode' : 'Dark mode';
  return <MenuButton iconLeft={icon} label={label} onClick={toggleTheme} />;
};
